<section>
  <app-form-header (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <astral-form
      [form]="form"
      [columns]="4"
      [tabletColumns]="2"
      [mobileColumns]="1"
      [columnGap]="'16px'"
      (formSubmit)="onSubmit()"
      >
      <section class="astral-grid-full astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-date-picker
            [control]="form.controls['publishFrom']"
            [label]="'POST.PUBLISH_FROM' | translate"
            [helpText]="'POST.HELP_TEXT.PUBLISH_FROM'"
          ></astral-date-picker>
          <astral-date-picker
            [control]="form.controls['publishTo']"
            [label]="'POST.PUBLISH_TO' | translate"
            [helpText]="'POST.HELP_TEXT.PUBLISH_TO'"
          ></astral-date-picker>
          <astral-input [control]="form.controls['sortOrder']" [helpText]="'POST.HELP_TEXT.SORT_ORDER'"></astral-input>
          <astral-textarea [control]="form.controls['title']" [rows]="2" [span]="'full'"></astral-textarea>
        </astral-layout-group>
        <astral-textarea [control]="form.controls['content']" [rows]="8"></astral-textarea>
      </section>
      <section class="astral-grid-full astral-section-surface astral-stack-m">
        <app-information-block [text]="'POST.POST_TARGET_INFO' | translate"></app-information-block>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [columnGap]="'16px'">
          <astral-typeahead [control]="targetFilterFormGroup.controls['company']" [itemsSource]="companiesSelect"></astral-typeahead>
          @if (companyHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['property']"
              [itemsSource]="propertiesSelect"
            ></astral-typeahead>
          }
          @if (propertyHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['building']"
              [itemsSource]="buildingsSelect"
            ></astral-typeahead>
          }
          @if (propertyHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['otherRentalObject']"
              [itemsSource]="otherRentalObjectsSelect"
            ></astral-typeahead>
          }
          @if (propertyHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['parking']"
              [itemsSource]="parkingsSelect"
            ></astral-typeahead>
          }
          @if (buildingHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['dwelling']"
              [itemsSource]="dwellingsSelect"
            ></astral-typeahead>
          }
          @if (buildingHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['premises']"
              [itemsSource]="premisesSelect"
            ></astral-typeahead>
          }
          @if (buildingHasValue) {
            <astral-typeahead
              [control]="targetFilterFormGroup.controls['entrance']"
              [itemsSource]="entrancesSelect"
            ></astral-typeahead>
          }
        </astral-layout-group>
        <div>
          <astral-button
            type="button"
            variant="primary"
            icon="plus"
            labelKey="POST.APPLY_BUTTON"
            (click)="applyTarget()"
            [disabled]="!this.targetFilterFormGroup.controls['company'].value"
          ></astral-button>
        </div>
        @if (form.controls['postTargets'].value.length === 0) {
          <i>
            {{ 'POST.POST_TARGET_EMPTY' | translate }}
          </i>
        }
        @if (form.controls['postTargets'].value.length > 0) {
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="small-icon-column">#</th>
                <th>{{ 'POST.POST_TARGET_TABLE.TARGET_NAME' | translate }}</th>
                <th class="small-icon-column"></th>
              </tr>
            </thead>
            <tbody>
              @for (postTarget of form.controls['postTargets'].value; track postTarget; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>
                    <p [innerHTML]="getPostTargetDescription(postTarget)"></p>
                  </td>
                  <td>
                    <astral-button type="button" variant="secondary" size="small" icon="trash" labelKey="DELETE_BTN" (click)="deleteTarget(i)"></astral-button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </section>
    </astral-form>
  }
</section>
